import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Divider,
  Dropdown,
  Row,
  Spin,
  Table,
  Tag,
  Typography,
} from "antd";
import {
  ArrowRightOutlined,
  LeftOutlined,
  SettingOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import { handleFlgStatus } from "../../../components/facilities/AccountFacility";

// Reuse the active-green style from handleFlgStatus for terminal states like "Completed"
const completedTagStyle = {
  backgroundColor: "#ECFDF3",
  border: "1px solid #ABEFC6",
  borderRadius: "16px",
  color: "#067647",
  padding: "2px 12px",
  fontSize: "12px",
  fontWeight: 500,
  display: "inline-block",
  textTransform: "capitalize",
};

const { Text, Title } = Typography;

const DUMMY_TRANSACTIONS = [
  {
    key: 1,
    id: 1,
    transactionDate: "01 January 2024",
    transactionType: "Cash Allocation",
    amount: "NGN 200,000.00",
    balance: "NGN 200,000.00",
    status: "Completed",
  },
  {
    key: 2,
    id: 2,
    transactionDate: "15 January 2024",
    transactionType: "Cash Settlement",
    amount: "NGN 150,000.00",
    balance: "NGN 50,000.00",
    status: "Completed",
  },
  {
    key: 3,
    id: 3,
    transactionDate: "20 February 2024",
    transactionType: "Cash Allocation",
    amount: "NGN 300,000.00",
    balance: "NGN 350,000.00",
    status: "Completed",
  },
];

const transactionColumns = [
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
    key: "transactionDate",
  },
  {
    title: "Transaction Type",
    dataIndex: "transactionType",
    key: "transactionType",
  },
  { title: "Amount", dataIndex: "amount", key: "amount" },
  { title: "Balance", dataIndex: "balance", key: "balance" },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (v) =>
      v?.toLowerCase() === "completed" ? (
        <Tag style={completedTagStyle}>{v}</Tag>
      ) : (
        handleFlgStatus(v, {}, true)
      ),
  },
];

const InfoRow = ({ label, value, last }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      borderBottom: last ? 0 : "1px solid #F3F4F6",
      minHeight: 40,
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F9FAFB")}
    onMouseLeave={(e) =>
      (e.currentTarget.style.backgroundColor = "transparent")
    }
  >
    <div
      style={{
        flex: "0 0 45%",
        padding: "8px 12px",
        backgroundColor: "#F8FAFC",
        borderRight: "1px solid #E5E7EB",
        fontWeight: 600,
        fontSize: 12,
        color: "#374151",
        minHeight: 40,
        display: "flex",
        alignItems: "center",
      }}
    >
      {label}
    </div>
    <div
      style={{
        flex: "0 0 28px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ArrowRightOutlined style={{ fontSize: 11, color: "#9ca3af" }} />
    </div>
    <div
      style={{
        flex: 1,
        padding: "8px 10px 8px 0",
        fontSize: 12,
        color: "#111827",
        display: "flex",
        alignItems: "center",
      }}
    >
      {value ?? "—"}
    </div>
  </div>
);

const SectionHeader = ({ title }) => (
  <div
    style={{
      fontSize: 11,
      fontWeight: 700,
      color: "#9ca3af",
      letterSpacing: 1,
      textTransform: "uppercase",
      marginBottom: 10,
    }}
  >
    {title}
  </div>
);

const DetailTeller = (props) => {
  const navigate = useNavigate();
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [tellerDetails, setTellerDetails] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("transactions");

  const tillId = state?.tillId;
  const tellerId = state?.id;

  useEffect(() => {
    getTemplate();
    console.log(tellerDetails);
  }, []);

  const breadcrumbItems = [
    {
      title: <Link to="/tlo0100">{labelConfig.manageLinkUserToTill}</Link>,
    },
    {
      title: (
        <Link to="/detail-tlo0100" state={{ id: tillId }}>
          {labelConfig.manageLinkUserToTillTeller}
        </Link>
      ),
    },
    { title: labelConfig.detailTeller },
  ];

  const getTemplate = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.Customizedteller}/${tellerId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        console.log(objList);

        const tempTeller = {
          id: objList?.id,
          tillProfileId: objList?.tellerProfile?.id,
          userName: objList?.appUser?.username ?? "—",
          tellerDescription: objList?.description ?? "—",
          status:
            objList?.status === "A"
              ? "Active"
              : objList?.status === "I"
                ? "Inactive"
                : (objList?.status ?? "—"),
          startDate: BOM.FormatArrayDate(objList?.startDate),
          endDate: BOM.FormatArrayDate(objList?.endDate),
        };

        setTellerDetails(tempTeller);
        setIsLoading(false);
      }
    });
  };

  const statusTag = handleFlgStatus(
    tellerDetails?.status || "Active",
    {},
    false,
  );

  const menuProps = {
    items: [
      {
        label: "Allocate Cash",
        key: "allocate",
        icon: <ArrowDownOutlined />,
      },
      {
        label: "Settle Cash",
        key: "settle",
        icon: <ArrowUpOutlined />,
      },
    ],
    onClick: ({ key }) => {
      switch (key) {
        case "allocate":
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Cash allocation initiated for this teller",
          );
          break;
        case "settle":
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Cash settlement initiated for this teller",
          );
          break;
        default:
          break;
      }
    },
  };

  const tabList = [{ key: "transactions", label: "Transactions" }];

  const contentListNoTitle = {
    transactions: (
      <Table
        columns={transactionColumns}
        dataSource={DUMMY_TRANSACTIONS}
        bordered
        pagination={{ position: ["bottomCenter"], pageSize: 10 }}
        size="small"
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={`Teller: ${tellerDetails?.userName ?? ""}`}
        pageItems={breadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={
              <Row style={{ alignContent: "center", width: "8%" }}>
                <Button
                  icon={<LeftOutlined />}
                  type="text"
                  style={{ marginTop: "auto", marginBottom: "auto" }}
                  onClick={() =>
                    navigate("/detail-tlo0100", { state: { id: tillId } })
                  }
                >
                  <Text
                    style={{
                      marginTop: "auto",
                      marginBottom: "auto",
                      fontSize: 15,
                    }}
                  >
                    Back
                  </Text>
                </Button>
              </Row>
            }
          >
            <Row style={{ marginBottom: 20 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="bottomLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>
            </Row>

            <SectionHeader title="Teller Information" />
            <Row gutter={24} style={{ marginBottom: 24 }}>
              <Col span={12}>
                <div
                  style={{
                    border: "1px solid #E5E7EB",
                    borderRadius: 10,
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      padding: "8px 12px",
                      background:
                        "linear-gradient(135deg, rgba(21,204,174,0.1) 0%, rgba(79,236,160,0.1) 100%)",
                      borderBottom: "1px solid #E5E7EB",
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#0d9488",
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    User Details
                  </div>
                  <InfoRow label="User Name" value={tellerDetails?.userName} />
                  <InfoRow
                    label="Description"
                    value={tellerDetails?.tellerDescription}
                  />
                  <InfoRow label="Status" value={statusTag} last />
                </div>
              </Col>

              <Col span={12}>
                <div
                  style={{
                    border: "1px solid #E5E7EB",
                    borderRadius: 10,
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      padding: "8px 12px",
                      background:
                        "linear-gradient(135deg, rgba(21,204,174,0.1) 0%, rgba(79,236,160,0.1) 100%)",
                      borderBottom: "1px solid #E5E7EB",
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#0d9488",
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    Assignment Period
                  </div>
                  <InfoRow
                    label="Till Profile ID"
                    value={tellerDetails?.tillProfileId}
                  />
                  <InfoRow
                    label="Start Date"
                    value={tellerDetails?.startDate}
                  />
                  <InfoRow
                    label="End Date"
                    value={tellerDetails?.endDate}
                    last
                  />
                </div>
              </Col>
            </Row>
          </Card>

          <Card
            styles={{ header: { borderBottomWidth: 0 } }}
            style={{
              width: "100%",
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
              marginTop: 24,
            }}
            tabList={tabList}
            activeTabKey={activeTabKey}
            onTabChange={(key) => setActiveTabKey(key)}
            tabProps={{ size: "middle" }}
          >
            {contentListNoTitle[activeTabKey]}
          </Card>
        </>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(DetailTeller);
